<template>
  <div :class="$style.root">
    <div :class="$style.header">
      <h5 :class="[$style.jaar, 'my-0']">
        {{ schooljaarString }}
      </h5>

      <div>
        <span :class="$style.label">aantal leerlingen: </span>
        <span :class="$style.value">{{ aantalLeerlingen }}</span>
      </div>
    </div>

    <div :class="$style.subjectContainer">
      <div :class="$style.valueContainer">
        <span :class="$style.label">zittenblijvers</span>
        <span :class="$style.value">{{ aantalZittenblijvers }}</span>
      </div>
      <div :class="$style.valueContainer">
        <span :class="$style.label">pct.</span>
        <span :class="$style.value">{{
          parseFloat((aantalZittenblijvers / aantalLeerlingen) * 100).toFixed(1)
        }}%
        </span>
      </div>
      <div :class="$style.valueContainer">
        <span :class="$style.label">gem. Amsterdam</span>
        <span :class="$style.value"> {{
          parseFloat(gemiddeldPctZittenblijversAms).toFixed(1)
        }}% </span>
      </div>
    </div>

    <div :class="$style.subjectContainer">
      <div :class="$style.valueContainer">
        <span :class="$style.label">afstromers</span>
        <span :class="$style.value">{{ aantalAfstromers }}</span>
      </div>
      <div :class="$style.valueContainer">
        <span :class="$style.label">pct.</span>
        <span :class="$style.value">{{
          parseFloat((aantalAfstromers / aantalLeerlingen) * 100).toFixed(1)
        }}%
        </span>
      </div>
      <div :class="$style.valueContainer">
        <span :class="$style.label">gem. Amsterdam</span>
        <span :class="$style.value"> {{
          parseFloat(gemiddeldPctAfstromersAms).toFixed(1)
        }}% </span>
      </div>
    </div>

    <div :class="$style.subjectContainer">
      <div :class="$style.valueContainer">
        <span :class="$style.label">opstromers</span>
        <span :class="$style.value">{{ aantalOpstromers }}</span>
      </div>
      <div :class="$style.valueContainer">
        <span :class="$style.label">pct.</span>
        <span :class="$style.value"> {{
          parseFloat((aantalOpstromers / aantalLeerlingen) * 100).toFixed(1)
        }}% </span>
      </div>
      <div :class="$style.valueContainer">
        <span :class="$style.label">gem. Amsterdam</span>
        <span :class="$style.value"> {{
          parseFloat(gemiddeldPctOpstromersAms).toFixed(1)
        }}% </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    schooljaarBegin: { required: true, type: Number },
    aantalLeerlingen: { type: Number, default: 0 },
    aantalZittenblijvers: { type: Number, default: 0 },
    aantalAfstromers: { type: Number, default: 0 },
    aantalOpstromers: { type: Number, default: 0 },
    gemiddeldPctZittenblijversAms: { type: Number, default: 0 },
    gemiddeldPctAfstromersAms: { type: Number, default: 0 },
    gemiddeldPctOpstromersAms: { type: Number, default: 0 },
  },

  computed: {
    schooljaarString() {
      return `${this.schooljaarBegin}-${(this.schooljaarBegin + 1).toString().substring(2)}
      naar ${this.schooljaarBegin + 1}-${(this.schooljaarBegin + 2).toString().substring(2)}`;
    },
  },
};
</script>

<style module lang="scss">
.root {
  box-shadow: 0 2px 4px #ccc;
}

.jaar {
  font-weight: bold;
  font-size: 90%;

}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px ;
  background-color: #f8f8f8;
}

.subjectContainer {
  display: flex;
  justify-content: space-around;
  padding: 0;

  &:last-child {
    .valueContainer {
      border-bottom: none;
    }
  }
}

.valueContainer {
  display: flex;
  width: calc(100% / 3);
  text-align: center;
  flex-direction: column;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #dee2e6;
}

.label {
  font-size: 80%;
}

.value {
  font-family: "futura-pt";
  font-size: 120%;
  font-weight: bold;
}
</style>
